const giftVisualiserWrapper = document.querySelector('#gift-visualiser-wrapper');
const giftVisualiserComponent = document.querySelector('#gift-visualiser-component');
const getMrOptions = (btn = null) => {
    setTimeout(() => {
        const mrButtons = document.querySelectorAll('.mr-quantity-option');
        let selectedBtn = btn;
        document.querySelectorAll('.gift').forEach(el => {
            el.classList.remove('unlocked');
            el.removeAttribute('style')
        })

        if (!btn) {
            const borders = [];
            mrButtons.forEach(btn => {
                const border = getComputedStyle(btn).border.toString();
                if (borders.includes(border)) {
                    borders.splice(borders.indexOf(border), 1);
                } else {
                    borders.push(border)
                }
            })


            selectedBtn = [...mrButtons].filter(btn => {
                const style = getComputedStyle(btn);
                const border = style.border;
                return borders.includes(border)
            })[0];
        }

        const btnIndex = [...mrButtons].indexOf(selectedBtn) + 1;

        const indices = [];
        for (let i = btnIndex; i >= 2; i--) {
            indices.push(i)
        }
        indices.forEach(ind => {
            const gifts = document.querySelectorAll(`[data-activate-on="${ind}"]`);
            gifts.forEach(giftEl => {
                const bg = giftEl.getAttribute('data-bg');
                giftEl.classList.add('unlocked');
                giftEl.classList.remove('locked');
                giftEl.setAttribute('style', `background:url('${bg}') no-repeat center;background-size:contain;`)
            })
        })
        const activatedGifts = document.querySelectorAll('.unlocked')
        const giftsUnlockedNUmber = document.querySelector('.giftsUnlockedNUmber');
        giftsUnlockedNUmber.innerText = `${activatedGifts.length}/${mrButtons.length}`

    }, 150)
}

const x = setInterval(() => {
    const mrButtons = document.querySelectorAll('.mr-quantity-option');
    if(Shopify.design_mode){
        clearInterval(x);
    }
    if (mrButtons.length) {
        clearInterval(x)
        giftVisualiserWrapper.appendChild(giftVisualiserComponent)
        giftVisualiserComponent.style.display = 'block'
        getMrOptions();
        mrButtons.forEach(btn => {
            btn.addEventListener('click', el => {
                console.log('btn clicked')
                getMrOptions(btn);
            })
        })
    }
}, 1000)
